module.exports = __webpack_public_path__ + "img/user-image-3.28587119.webp";